"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositFundsIntoMatic = void 0;
var abi_1 = require("@ethersproject/abi");
var utils_1 = require("../utils");
var types_1 = require("../types");
var encodeMaticDeposit = function (recipientAddress, mainnetTokenAddress, tokenDeposit) {
    return new abi_1.Interface(["function depositFor(address,address,bytes)"]).encodeFunctionData("depositFor(address,address,bytes)", [recipientAddress, mainnetTokenAddress, abi_1.defaultAbiCoder.encode(["uint256"], [tokenDeposit])]);
};
var maticErc20DepositTransaction = function (rootChainManagerProxy, tokenAddress, recipientAddress, amount) { return ({
    to: rootChainManagerProxy,
    typeCode: types_1.CallType.Call,
    data: encodeMaticDeposit(recipientAddress, tokenAddress, amount),
    value: "0",
}); };
exports.depositFundsIntoMatic = function (maticBridgeAddresses, recipientAddress, tokenAddress, depositAmount) {
    var rootChainManagerProxy = maticBridgeAddresses.rootChainManagerProxy, erc20PredicateProxy = maticBridgeAddresses.erc20PredicateProxy;
    return [
        utils_1.erc20ApprovalTransaction(tokenAddress, erc20PredicateProxy, depositAmount),
        maticErc20DepositTransaction(rootChainManagerProxy, tokenAddress, recipientAddress, depositAmount),
    ];
};
